import get from 'lodash/get';
import { GENERATIVE_SETTINGS, DEFAULT_GEN_SETTINGS } from './DashboardMockConstants';

export const FETCH_DELAY = 500;

/**
 * getResponse
 * Mocking a fetch call to server by setting a timeout in a promise.
 * @param { Object } data: Data to return when promise is resolved.
 * @returns { Promise } Resolved promised with given data.
 */
export const getResponse = (data) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data });
    }, FETCH_DELAY);
  });

/**
 * mockGet
 * Mocking a get call to server by setting a timeout in a promise.
 * @param { String } url: The url to make the get call to.
 * @param { Object } params: Additional params for the call.
 * @param { Object } response: Data to return when promise is resolved.
 * @returns { Promise } Resolved promised with given data.
 */
export const mockGet = (_url, _params, response) => getResponse(response);

/**
 * mockPost
 * Mocking a post call to server by setting a timeout in a promise.
 * @param { String } url: The url to make the post call to.
 * @param { Object } params: Additional params for the call.
 * @param { Object } response: Data to return when promise is resolved.
 * @returns { Promise } Resolved promised with given data.
 */
export const mockPost = (_url, _params, response) => getResponse(response);

/**
 * mockDelete
 * Mocking a delete call to server by setting a timeout in a promise.
 * @param { String } url: The url to make the delete call to.
 * @param { Object } response: Data to return when promise is resolved.
 * @returns { Promise } Resolved promised with given data.
 */
export const mockDelete = (_url, response) => getResponse(response);

/**
 * getGenerativeSettings
 * returns the generative settings for a specific mock chart.
 * @param { Object } props: the props.
 * @returns { Object } The generative settings.
 */
export const getGenerativeSettings = (props = {}) => {
  const name = get(props, 'metric.enumName');
  return GENERATIVE_SETTINGS[name] || DEFAULT_GEN_SETTINGS;
};

/**
 * getMockSeriesSegmentCount
 * returns the amount of segment steps to display for mock series generation
 * @param { Object } props: the props.
 * @returns { Number } The amount of segments.
 */
export const getMockSeriesSegmentCount = (props = {}) => {
  const { startTime, endTime } = props;
  const difference = endTime - startTime;
  const milliscondsPerDay = 86400000;
  return Math.floor(difference / milliscondsPerDay) || 1;
};

export default {
  get: mockGet,
  post: mockPost,
  delete: mockDelete,
  getResponse,
};
